/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import getDateLocaleFormat from './getDateLocaleFormat.js';

var getDateLocalePlaceholder = function getDateLocalePlaceholder(locale) {
  var formattedDate = getDateLocaleFormat(locale);
  return formattedDate.replace(/Y/, 'yyyy').replace(/m/, 'mm').replace(/d/, 'dd');
};
var getDateLocalePlaceholder$1 = getDateLocalePlaceholder;

export { getDateLocalePlaceholder$1 as default };
